export default "__VITE_ASSET__2a089f36__"